import styled, { css } from 'styled-components';
import { colors, transparentColors } from '../../variables/colors.js';
import { transitions } from '../../variables/transitions.js';
import { deviceWidths } from '../../variables/widths.js';

var Wrapper = styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-uob51s-0"
})(["height:80px;position:relative;"]);
var ControlLineWrapper = styled.div.withConfig({
  displayName: "style__ControlLineWrapper",
  componentId: "sc-uob51s-1"
})(["cursor:pointer;height:24px;"]);
var ControlLine = styled.div.withConfig({
  displayName: "style__ControlLine",
  componentId: "sc-uob51s-2"
})(["background:", ";height:4px;position:relative;width:100%;", ""], colors.darkCore, function (props) {
  return props.theme === 'blue' && css(["background:", ";"], colors.wave);
});
var ControlLineBackground = styled(ControlLine).withConfig({
  displayName: "style__ControlLineBackground",
  componentId: "sc-uob51s-3"
})(["background:", ";margin-top:10px;position:absolute;right:0;"], colors.lightGray);
var Handle = styled.div.withConfig({
  displayName: "style__Handle",
  componentId: "sc-uob51s-4"
})(["background:", ";border-radius:20px;box-shadow:0 0 5px ", ";cursor:pointer;display:block;height:32px;position:absolute;top:-14px;transition:box-shadow ", ";width:32px;@media (min-width:", "){height:24px;top:-10px;width:24px;}.no-touch &:hover{box-shadow:0 0 5px ", ";}"], colors.white, transparentColors.semiTransparentblack50, transitions["default"], deviceWidths.tablet, transparentColors.semiTransparentblack70);
var MaxValueLabel = styled.div.withConfig({
  displayName: "style__MaxValueLabel",
  componentId: "sc-uob51s-5"
})(["margin-top:10px;position:absolute;right:0;"]);
var MinValueLabel = styled.div.withConfig({
  displayName: "style__MinValueLabel",
  componentId: "sc-uob51s-6"
})(["left:0;margin-top:10px;position:absolute;"]);
var CurrentValueWrapper = styled.div.withConfig({
  displayName: "style__CurrentValueWrapper",
  componentId: "sc-uob51s-7"
})(["margin-bottom:10px;text-align:center;"]);
var CurrentValue = styled.span.withConfig({
  displayName: "style__CurrentValue",
  componentId: "sc-uob51s-8"
})(["&:after{content:' ';}&:last-child::after{content:'';}"]);

export { ControlLine, ControlLineBackground, ControlLineWrapper, CurrentValue, CurrentValueWrapper, Handle, MaxValueLabel, MinValueLabel, Wrapper };
//# sourceMappingURL=style.js.map
